import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {UserService} from "../user/user.service";
import {UserStateService} from "../user/user.state.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import { MatFormFieldModule} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {MatCheckbox} from '@angular/material/checkbox';
import {NavStatusService} from '../nav-status.service';
import {NavigationPoint} from '../navigation-point';
import {TranslatePipe} from '@ngx-translate/core';
import {SnackBarService} from "../common/snack-bar-service";
import {DOCUMENT} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-login',
    imports: [FormsModule, ReactiveFormsModule, MatInput, MatFormFieldModule, MatButton, MatCheckbox, TranslatePipe, RouterLink],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, OnDestroy {

    loginForm: FormGroup;
    public errorMessage: string | undefined;
    prdDomain: string | undefined = undefined;
    domainsToCheck: string[] = ['head', 'mares', 'tyrolia', 'divessi', 'zoggs' ];
    isTestServer: boolean = false;
    paramSubscription: Subscription | undefined;

    constructor(
        private userService: UserService,
        private userStateService: UserStateService,
        private router: Router,
        private fb: FormBuilder,
        private navStatusService: NavStatusService,
        private snackbarService: SnackBarService,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.loginForm = this.fb.group({
            username: [null, [Validators.required]],
            password: [null, [Validators.required]],
            _remember_me: [null, []],
        })
    }
    ngOnInit(): void {
        this.paramSubscription = this.route.queryParams.subscribe(params => {
           // console.log(params);
            if (params['doReload']) {
                const queryParams = {};
                this.router.navigate([], { queryParams, replaceUrl: true, relativeTo: this.route }).then(() => {
                   // console.log('reloading page');
                    window.location.reload();
                }
                );

            }
        })
        this.navStatusService.setActiveNavPoint(NavigationPoint.login);
        this.snackbarService.hideMessage();
        this.isTestServer = this.checkForTst();
    }
    checkForTst(): boolean {
        const domain = document.location.host;
        let i: number = domain.indexOf('test');
        if (i !== -1 || domain === 'localhost:4200') {
            for(const entry of this.domainsToCheck) {
                let k: number = domain.indexOf(entry);
                if (k !== -1) {
                   this.prdDomain = 'https://dam.' + entry + '.com';
                   return true
                }
            }
            this.prdDomain = 'http://localhost:4200/login';
            return true;

        }
        return false;
    }

    login() {
        this.userService.login(this.loginForm.value).subscribe({
            next: (user) => {
              //  console.log('login successful', user);
                this.userStateService.user = user
                this.router.navigate(['/']).then();
            },
            error: (error) => {
               // console.error('login failed', error);
                this.errorMessage = error;
            }
        });
    }
    ngOnDestroy() {
        if (this.paramSubscription) {
            this.paramSubscription.unsubscribe();
        }
    }
}
